var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-search-screen"},[_c('PostSearchHeader'),_c('div',{staticClass:"post-search-screen__content"},[_c('PostSearchFilters',{attrs:{"is-loading":_vm.isLoading},on:{"goSearch":_vm.goSearch}}),_c('SearchPostsList',{attrs:{"is-loading":_vm.isLoading},on:{"goSearch":_vm.goSearch}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }